import { FOOTER_STRINGS } from "../constants/strings";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      © {currentYear} {FOOTER_STRINGS.brand}
    </footer>
  );
}

export default Footer;
